import { PaginationInfo } from 'types';
import { getType } from 'typesafe-actions';
import { DEFAULT_PAGEINFO } from '../../../../constants';
import { activitiesActions, ActivitiesActions } from '../creators';

const pageInfoReducer = (state: PaginationInfo = DEFAULT_PAGEINFO, action: ActivitiesActions) => {
  switch (action.type) {
    case getType(activitiesActions.getActivitiesRequest.success):
      const { items, ...rest } = action.payload;
      return { ...state, ...rest };

    case getType(activitiesActions.setPage):
      return { ...state, pageIndex: action.payload };

    case getType(activitiesActions.setPageSize):
      return { ...state, pageSize: action.payload };

    default:
      return state;
  }
};

export default pageInfoReducer;
